module.exports = __webpack_public_path__ + "static/media/launch_icon.7fbd27f6.png";